import { JsonServiceClient } from "@servicestack/client";
import * as React from 'react';
import { connect } from 'react-redux';
import { actions, Control, LocalForm } from 'react-redux-form';
import { bindActionCreators } from "redux";
import * as CREDtos from "../../CRE.dtos";
import { Spinner } from '../Controls/Spinner';
const queryString = require('query-string');

class ContactUs extends React.Component<any, any> {

    formDispatch;

    constructor(props, context) {
        super(props, context);

        let location = this.props.location;
        location.query = queryString.parse(location.search);
        this.state = { otherClicked: false, location: location, sentError: undefined, showSending: false, showSuccessSent: false };

        this.onLocalSubmit = this.onLocalSubmit.bind(this);
        this.onOtherClicked = this.onOtherClicked.bind(this);
        this.submitContactUs = this.submitContactUs.bind(this);
    }

    onLocalSubmit(values) {
        this.submitContactUs(values);
    }

    componentDidMount() {

        window.scrollTo(0, 0);

        if (this.state.location.query["type"] == "donation") {
            this.formDispatch(actions.load('contactUsMessage.donation', true));
        }

        if (this.state.location.query["type"] == "researchTraining") {
            this.formDispatch(actions.load('contactUsMessage.researchTraining', true));
        }

        if (this.state.location.query["type"] == "researchInvolvement") {
            this.formDispatch(actions.load('contactUsMessage.researchInvolvement', true));
        }

        if (this.state.location.query["type"] == "enquiry") {
            this.formDispatch(actions.load('contactUsMessage.enquiry', true));
        }

        if (this.state.location.query["type"] == "news") {
            this.formDispatch(actions.load('contactUsMessage.news', true));
        }

        if (this.state.location.query["type"] == "other") {
            this.onOtherClicked();

            this.formDispatch(actions.load('contactUsMessage.other', true));

            if (this.state.location.query["msg"]) {
                this.formDispatch(actions.load('contactUsMessage.otherDescription', this.state.location.query["msg"]));
            }
        }

    }

    async submitContactUs(values) {


        this.setState({ showSending: true, sentError: undefined });

        var client = new JsonServiceClient("/");

        var contactUsRequest = new CREDtos.ContactUsMessage();
        //contactUsRequest = { ...values };
        contactUsRequest.collaborating = values.collaborating;
        contactUsRequest.donation = values.donation;
        contactUsRequest.email = values.email;
        contactUsRequest.phone = values.phone;
        contactUsRequest.enquiry = values.enquiry;
        contactUsRequest.firstName = values.firstName;
        contactUsRequest.lastName = values.lastName;
        contactUsRequest.message = values.message;
        contactUsRequest.news = values.news;
        contactUsRequest.other = values.other;
        contactUsRequest.otherDescription = values.otherDescription;
        contactUsRequest.researchInvolvement = values.researchInvolvement;
        contactUsRequest.researchTraining = values.researchTraining;
        contactUsRequest.state = values.state;

        try {
            await client.post(contactUsRequest);
            this.handleReset();
            this.setState({ showSuccessSent: true, showSending: false });
        } catch (e) {
            this.setState({ sentError: e.responseStatus.message, showSending: false });
        }
    }

    onOtherClicked() {
        this.setState({ otherClicked: !this.state.otherClicked });
    }

    handleReset() {
        this.formDispatch(actions.reset('contactUsMessage')); // or whatever model you gave to <LocalForm>
    }

    render() {
        if (!this.props.contactUsSettings || this.props.isLoading) {
            return (
                <Spinner isOpen={this.props.isLoading} />
            );
        }

        const settings = this.props.contactUsSettings;

        const required = value => value ? undefined : 'Required';
        const email = value =>
            value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ?
                'Invalid email address' : undefined;
        let errorMsg = this.state.sentError ? <div className="alert alert-danger">{this.state.sentError}</div> : undefined;
        let sendButton = this.state.showSending ? <span><i className="fa fa-spinner fa-spin fa-lg fa-fw"></i>
            sending...</span> : <span>send</span>;
        let successMsg = this.state.showSuccessSent ? <div className="alert alert-default">Thank you, your email has been sent.</div> : undefined;
        let otherDescription = this.state.otherClicked ? <Control.text model=".otherDescription" className="form-control form-control" placeholder="please specify" /> : undefined;
       return (
            <div id="SectionContainer">
            <LocalForm model="contactUsMessage" onSubmit={this.onLocalSubmit.bind(this)} getDispatch={(dispatch) => this.formDispatch = dispatch}>
                <section className="content">
                    <div className="container page-content">
                        <h1   style={{ color: 'black' }} >CONTACT US</h1>
                    </div>
                    <div className="container">
                        <div className="col-12">
                            <div className="container news-item">
                                <div className="row">
                                    <div className="col-12 col-lg-7 ">
                                        <div className="mr-5">
                                            <div className="row ml-1">
                                                <div className="col-12 mb-1"> 
                                                    {errorMsg}
                                                    <strong>I am emailing about:</strong>
                                                </div>
                                                <div className="col-12 checkbox">
                                                    <label className=" checkbox">
                                                        <Control.checkbox model=".researchTraining" /><span className="cr"><i className="cr-icon fa fa-check"></i></span>
                                                        Research training (PhDs, research masters, support, traineeships)
                                                </label>
                                                </div>
                                                <div className="col-12 checkbox">
                                                    <label><Control.checkbox model=".researchInvolvement" /><span className="cr"><i className="cr-icon fa fa-check"></i></span>
                                                        Research involvement
                                                </label>
                                                </div>
                                                <div className="col-12 checkbox">
                                                    <label className=""><Control.checkbox model=".collaborating" />
                                                        <span className="cr"><i className="cr-icon fa fa-check"></i></span>
                                                        Collaborating with us
                                                </label>
                                                </div>
                                                <div className="col-12 checkbox">
                                                    <label ><Control.checkbox model=".news" />
                                                        <span className="cr"><i className="cr-icon fa fa-check"></i></span> 
                                                        Signing up to get our news
                                                </label>
                                                </div>
                                                <div className="col-12 checkbox">
                                                    <label><Control.checkbox model=".enquiry" />
                                                        <span className="cr"><i className="cr-icon fa fa-check"></i></span> 
                                                        Media enquiry
                                                </label>
                                                </div>
                                                <div className="col-12 checkbox">
                                                    <label><Control.checkbox model=".donation" />
                                                        <span className="cr"><i className="cr-icon fa fa-check"></i></span>
                                                        Making a donation
                                                </label>
                                                </div>
                                                <div className="col-12 checkbox">
                                                    <label >
                                                        <Control.checkbox model=".other" onClick={this.onOtherClicked}/>
                                                        <span className="cr"><i className="cr-icon fa fa-check"></i></span> Other
                                                </label>
                                                    {otherDescription}
                                                </div>
                                            <div className="col-12">
                                            <div className="mt-3"><strong>About me:</strong></div>
                                            <div className="row form-group mb-1">
                                                    <div className="col-12 col-sm-5">
                                                            <label className=" col-form-label col-form-label">My first name</label>
                                                    </div>
                                                    <div className="col-12 col-sm-7">
                                                            <Control.text model=".firstName" className="form-control form-control" placeholder="First Name" />
                                                    </div>
                                            </div>
                                            <div className="row form-group mb-1">
                                                <div className="col-12 col-sm-5">
                                                            <label className=" col-form-label col-form-label">My last name</label>
                                                </div>
                                                <div className="col-12 col-sm-7">
                                                            <Control.text model=".lastName" className="form-control form-control" placeholder="Last Name" />
                                                </div>
                                            </div>
    
                                            <div className="row form-group mb-1">
                                                <div className="col-12 col-sm-5 ">
                                                            <label className="col-form-label col-form-label">My email</label>
                                                </div>
                                                <div className="col-12 col-sm-7">
                                                    <Control.text model=".email" className="form-control form-control" placeholder="Email" />
                                                    </div>
                                            </div>
    
                                            <div className="row form-group mb-1">
                                                <div className="col-12 col-sm-5 ">
                                                            <label className="col-form-label col-form-label">My phone number</label>
                                                </div>
                                                <div className="col-12 col-sm-7">
                                                    <Control.text model=".phone" className="form-control form-control" placeholder="Phone" />
                                                </div>
                                            </div>
                                            <div className="row form-group mb-1">
                                                <div className="col-12 col-sm-5">
                                                            <label className=" col-form-label col-form-label">State or territory where I live</label>
                                                </div>
                                                <div className="col-12 col-sm-7">
                                                    <Control.text model=".state" className="form-control form-control" placeholder="State / Territory" />
                                                </div>
                                            </div>
                                            <div className="row form-group mb-3">
                                                <div className="col-12 col-sm-5">
                                                            <label className=" col-form-label col-form-label">Add a message</label>
                                                </div>
                                                <div className="col-12 col-sm-7">
                                                    <Control.textarea model=".message" className="form-control form-control" placeholder="Your message..." />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="offset-sm-5 col-12 col-sm-7">
                                                    <button type="submit" disabled={this.state.showSending} className="btn btn-primary btn-block">
                                                                {sendButton}
                                                    </button>
                                                </div>
                                                <div className="col-12 pt-2">
                                                        {successMsg}
                                                </div>
                                            </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-5 white-border pl-5 mt-3 pt-3 mt-lg-0 pt-lg-0">
                                        <div>
                                                <strong>Want to chat?</strong></div>
                                                Tel: 02 9515 6420
                                                <div className="mt-3"><strong>Address:</strong></div>
                                                The University of Sydney<br />
                                                Faculty of Medicine and Health<br />
                                                Discipline of Addiction Medicine<br />
                                                Centre of Research Excellence in Indigenous Health and Alcohol <br />
                                                <div className="mt-3">Based at: 
                                                King George V Building<br />
                                                Missenden Road<br/>
                                                Camperdown New South Wales 2050
                                            </div>
                                        </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                
    
    
            </LocalForm>
            </div>);
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        contactUsSettings: state.siteData.siteData.contactUsSettings,
        isLoading: state.siteData.isLoading
    };
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {},
        dispatch
    );
};


const ContactUsnContainer = connect(mapStateToProps, mapDispatchToProps)(
    ContactUs
);

export default ContactUsnContainer;


// WEBPACK FOOTER //
// ./src/components/ContactUs/ContactUs.tsx